import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useAdminUpdateListingPricingMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, ...t }) => r.updatePricing(e, t),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) }), i.invalidateQueries({ queryKey: ["admin-listings", "list"] });
		}
	});
};
//#endregion
export { i as useAdminUpdateListingPricingMutation };
